module.exports = __webpack_public_path__ + "static/bYo0YeEr_400x400-21ab790840469ad7da64a0fab6e1a3f1.jpg";